import type { AnyAction } from 'redux';
import { put, call, takeEvery } from 'redux-saga/effects';
import path from 'ramda/src/path';
import {
  getParamUserToken,
  getParamProxyPrefix,
  getParamDepositUrl,
  getParamUserData,
  setParamUserData,
  setParamUserToken,
  USER_LOGIN,
  USER_LOGOUT,
} from '@corefront/redux-aba';

export function* login() {
  yield put(getParamUserToken());
  yield put(getParamProxyPrefix());
  yield put(getParamDepositUrl());
  yield put(getParamUserData());
}

export function* logout() {
  yield put(setParamUserToken(''));
  yield put(getParamProxyPrefix());
  yield put(getParamDepositUrl());
  yield put(setParamUserData({} as any));
}

export function* authorizationWorker(action: AnyAction) {
  if (action.type === USER_LOGIN) {
    const method = path(['error'], action.payload) ? logout : login;
    yield call(method);
  }

  if (action.type === USER_LOGOUT) {
    yield call(logout);
  }
}

export function* authorizationWatcher() {
  yield takeEvery([USER_LOGIN, USER_LOGOUT], authorizationWorker);
}
